import { render, staticRenderFns } from "./notificationCounter.vue?vue&type=template&id=216382f5&scoped=true&lang=html&"
import script from "./notificationCounter.vue?vue&type=script&lang=js&"
export * from "./notificationCounter.vue?vue&type=script&lang=js&"
import style0 from "./notificationCounter.vue?vue&type=style&index=0&id=216382f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216382f5",
  null
  
)

export default component.exports